const middleware = {}

middleware['appData'] = require('../middleware/appData.js')
middleware['appData'] = middleware['appData'].default || middleware['appData']

middleware['redirect'] = require('../middleware/redirect.js')
middleware['redirect'] = middleware['redirect'].default || middleware['redirect']

export default middleware
